var QRCode = require('vendor/qrcode')
  , $ = require('jquery')
  , urlUtils = require('@173js/url')

module.exports = function(selector, context, options) {
  options = options || {}
  $(context).find(selector).each(function(i, el) {
    var url = urlUtils.addParam(
        $(el).data('url') || window.location.href
      , { f: 'scan' } // For bi's track
      )

    var qrcode = new QRCode(el
      , $.extend({
          text: url
        , width: 110
        , height: 110
      }, options))
  })
};
